export default __webpack_public_path__ + "static/media/portfolio4.b2e5ad34.jpg";